import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilGerente, usuarioPerfilRepresentante } from '../../../home/usuario';

export const canAccessAIPage: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente];

@Injectable({
  providedIn: 'root',
})
export class CanActivateAIPage implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const perfil = this.authService.getPerfilUsuario();

    if (!perfil) {
      this.router.navigate(['/login']);
      return false;
    }

    if (!canAccessAIPage.includes(perfil) || !this.authService.canAccessAIPage()) {
      this.router.navigate(this.authService.getDefaultRoute());
      return false;
    }

    return true;
  }
}
